import { Decimal } from 'decimal.js';

// fix 0.1 + 0.2 = 0.30000000000000004
export function safeAdd(x: number, y: number) {
	return Decimal.add(x, y).toNumber();
}
